import React from "react";
import Axios from "../config/AxiosConfig";
import RichTextEditor from "./Editor/Editor";
import {
  EditorState,
  convertToRaw,
  convertFromRaw,
  AtomicBlockUtils,
} from "draft-js";
import Cookies from "universal-cookie";
import Modal from "react-awesome-modal";
import { useParams } from "react-router-dom";
const cookies = new Cookies();

export default function AdminPostUpdate() {
  const { post_id } = useParams();
  return <AdminPostEdit post_id={post_id} />
}

class AdminPostEdit extends React.Component {
  state = {
    feed_title: "",
    feed_subtitle: "",
    feed_brief: "",
    feed_description: EditorState.createEmpty(),
    feed_activation: false,
    feed_show_in_app: true,
    feed_show_in_web: false,
    curated_by: "",
    feed_share_message: "",
    feed_image: {
      file: "#",
    },
    feed_detail_image: {
      file: "#",
    },
    feed_description_image: {
      file: "#",
    },
    feed_character_count: 0,
    show_to_league: true,
    league_id: null,
    error: "",
    visible: false,
    feed_url: ''
  };
  async componentDidMount() {
    const { post_id } = this.props;

    const post_data = await getParticularPost(post_id);
    console.log("post_data", post_data);
    const {
      response: { results },
    } = post_data;

    this.setState({
      feed_title: results[0].feed_title,
      feed_subtitle:
        results[0].feed_subtitle === null ? "" : results[0].feed_subtitle,
      feed_brief: results[0].feed_brief,
      feed_description: this.setEditorContent(results[0].feed_description),
      feed_activation: results[0].is_active,
      feed_show_in_app: results[0].is_visible_on_app,
      feed_show_in_web: results[0].is_visible_on_web,
      feed_image: {
        file: results[0].feed_image,
      },
      feed_detail_image: {
        file: results[0].feed_detail_page_image,
      },
      feed_character_count: results[0].post_word_count,
      curated_by: results[0].curated_by ? results[0].curated_by : "",
      feed_share_message: results[0].share_message
        ? results[0].share_message
        : "",
      show_to_league: true,
      league_id: null,
      feed_url: results[0].feed_url ? results[0].feed_url : ''
    });
  }

  setEditorContent(feed_description) {
    const rawEditorData = feed_description
      ? JSON.parse(feed_description)
      : null;
    if (rawEditorData !== null) {
      const contentState = convertFromRaw(rawEditorData);
      return EditorState.createWithContent(contentState);
      // this.setState({ editorState: newEditorState });
    }
  }
  getContentAsRawJson(editorState) {
    const contentState = editorState.getCurrentContent();
    const raw = convertToRaw(contentState);

    return JSON.stringify(raw);
  }
  updateFeed = async (data) => {
    try {
      const { post_id } = this.props;

      let feed_object = {
        feed_title: this.state.feed_title,
        feed_subtitle: this.state.feed_subtitle,
        feed_brief: this.state.feed_brief,
        feed_description: this.getContentAsRawJson(this.state.feed_description),
        is_active: this.state.feed_activation || false,
        is_visible_on_app: this.state.feed_show_in_app,
        is_visible_on_web: this.state.feed_show_in_web,
        feed_image: this.state.feed_image.file,
        feed_detail_page_image: this.state.feed_detail_image.file,
        post_character_count: getPostWordCount(this.state.feed_description),
        curated_by: this.state.curated_by,
        share_message: this.state.feed_share_message,
        show_to_league: this.state.show_to_league,
        league_id: this.state.league_id,
        feed_url: this.state.feed_url
      };

      const update_feed = await Axios.put(`/webposts/${post_id}`, feed_object, {
        headers: {
          authorization: cookies.get("authorization"),
        },
      });
      let is_update = JSON.parse(JSON.stringify(update_feed.data));
      if (is_update.code >= 200 && is_update.code < 300) {
        this.openModal();
      }
    } catch (error) {
      console.log("error", error);
    }
  };
  handleUpload = async (image_object, image_section) => {
    try {
      if (image_object.file_name === undefined) {
        return;
      }

      let url = "/upload_image";
      const full_image_url = await Axios.post(url, image_object, {
        headers: {
          authorization: cookies.get("authorization"),
        },
      });
      if (image_section === "MAIN_IMAGE") {
        this.setState({ feed_image: { file: full_image_url.data.image_url } });
      } else if (image_section === "IMAGE_DETAIL") {
        this.setState({
          feed_detail_image: { file: full_image_url.data.image_url },
        });
      } else if (image_section === "IMAGE_DESC") {
        const newEditorState = this.insertImage(
          this.state.feed_description,
          full_image_url.data.image_url
        );
        this.handleEditorChange(newEditorState);
        this.setState({
          feed_description_image: { file: "#" },
        });
      } else return;
    } catch (error) {
      console.log(error);
    }
  };
  showImage = async (image_section, input) => {
    const { files } = input.target;
    if (files.length > 0) {
      const file_name =
        new Date().getTime() + files[0].name.replace(/\s/g, "-");
      const file_type = files[0].type;
      const reader = new FileReader();
      reader.readAsDataURL(files[0]);
      let image_obj = {
        file_name,
        file_type,
      };
      reader.onload = async (image) => {
        image_obj.file = image.target.result;
        if (image_section === "MAIN_IMAGE") {
          image_obj.feed_title = `${this.state.feed_title.replace(
            /\s/g,
            "-"
          )}/feed_title`;
          this.setState({
            feed_image: image_obj,
          });
        } else if (image_section === "IMAGE_DETAIL") {
          image_obj.feed_title = `${this.state.feed_title.replace(
            /\s/g,
            "-"
          )}/feed_subtitle`;
          this.setState({
            feed_detail_image: image_obj,
          });
        } else if (image_section === "IMAGE_DESC") {
          image_obj.feed_title = `${this.state.feed_title.replace(
            /\s/g,
            "-"
          )}/feed_description`;
          this.setState({
            feed_description_image: image_obj,
          });
          this.handleUpload(image_obj, "IMAGE_DESC");
        }
      };
    } else {
      if (image_section === "MAIN_IMAGE") {
        this.setState({
          feed_image: "#",
        });
        return;
      } else if (image_section === "IMAGE_DETAIL") {
        this.setState({
          feed_detail_image: "#",
        });

        return;
      } else if (image_section === "IMAGE_DESC") {
        this.setState({
          feed_description_image: "#",
        });
        return;
      } else {
        return;
      }
    }
  };

  handleFeedTitleChange = (e) => {
    const { value, maxLength } = e.target;
    const message = value.slice(0, maxLength);
    if (message.length >= maxLength) {
      this.setState({
        error: "Max length can be 100 characters only",
      });
    } else {
      this.setState({
        error: "",
        feed_title: e.target.value,
      });
    }
  };
  handleEditorChange = (editor) => {
    this.setState({
      feed_description: editor,
    });
  };
  handleWordCount = (word_count) => {
    // try {
    //   this.setState({
    //     feed_character_count: word_count
    //   });
    // } catch (error) {
    //   console.log(error);
    // }
  };

  insertImage = (editorState, base64) => {
    const contentState = editorState.getCurrentContent();
    const contentStateWithEntity = contentState.createEntity(
      "image",
      "IMMUTABLE",
      { src: base64 }
    );
    const entityKey = contentStateWithEntity.getLastCreatedEntityKey();
    const newEditorState = EditorState.set(editorState, {
      currentContent: contentStateWithEntity,
    });
    return AtomicBlockUtils.insertAtomicBlock(newEditorState, entityKey, " ");
  };
  openModal() {
    this.setState({
      visible: true,
    });
  }

  closeModal() {
    this.setState({
      visible: false,
    });
  }
  render() {
    return (
      <div className="container">
        <div>
          <h2
            style={{
              textAlign: "center",
              textTransform: "uppercase",
              padding: "10px",
              marginTop: "40px",
            }}
          >
            Update Feed
          </h2>
        </div>
        <p style={{ color: "red" }}>{this.state.error}</p>
        <div className="row">
          <div className="col-25">
            <label htmlFor="feed_title">Feed Title</label>
          </div>
          <div className="col-75">
            <input
              type="text"
              id="feed_title"
              name="title"
              value={this.state.feed_title}
              onChange={this.handleFeedTitleChange}
              placeholder="Add feed title.."
              maxLength="101"
            />
          </div>
        </div>
        <div className="row">
          <div className="col-25">
            <label htmlFor="feed_brief">Feed Brief</label>
          </div>
          <div className="col-75">
            <input
              type="text"
              id="feed_brief"
              name="brief"
              value={this.state.feed_brief}
              onChange={(e) => this.setState({ feed_brief: e.target.value })}
              placeholder="Add feed brief.."
            />
          </div>
        </div>
        <div className="row">
          <div className="col-25">
            <label htmlFor="feed_image">Feed Image</label>
          </div>
          <div className="col-75">
            <input
              type="file"
              id="feed_image"
              name="list-image"
              onChange={this.showImage.bind(this, "MAIN_IMAGE")}
              placeholder="Add feed image.."
            />
            <button
              className="btn-feed"
              onClick={this.handleUpload.bind(
                this,
                this.state.feed_image,
                "MAIN_IMAGE"
              )}
            >
              Upload Image
            </button>
            <div
              style={{ margin: "10px 0" }}
              className={
                this.state.feed_image.file === "#" ? "inactive-class" : ""
              }
            >
              <img
                src={this.state.feed_image.file}
                alt="feed-main"
                style={{ maxWidth: "200px" }}
              />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-25">
            <label htmlFor="feed_subtitle">Feed Subtitle</label>
          </div>
          <div className="col-75">
            <input
              type="text"
              id="feed_subtitle"
              name="subtitle"
              value={this.state.feed_subtitle}
              onChange={(e) => this.setState({ feed_subtitle: e.target.value })}
              placeholder="Add feed sub title.."
            />
          </div>
        </div>
        <div className="row">
          <div className="col-25">
            <label htmlFor="feed_detail_image">Detail Page Image</label>
          </div>
          <div className="col-75">
            <input
              type="file"
              id="feed_detail_image"
              name="detail-image"
              onChange={this.showImage.bind(this, "IMAGE_DETAIL")}
              placeholder="Add feed detail page image.."
            />
            <button
              className="btn-feed"
              onClick={this.handleUpload.bind(
                this,
                this.state.feed_detail_image,
                "IMAGE_DETAIL"
              )}
            >
              Upload Image
            </button>
            <div
              style={{ margin: "10px 0" }}
              className={
                this.state.feed_detail_image.file === "#"
                  ? "inactive-class"
                  : ""
              }
            >
              <img
                src={this.state.feed_detail_image.file}
                alt="feed-detail"
                style={{ maxWidth: "200px" }}
              />
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-25">
            <label htmlFor="feed_description">Feed Description</label>
          </div>
          <div className="col-75">
            {/* <input
              type="text"
              id="feed_description"
              name="description"
              value={this.state.feed_description}
              onChange={e =>
                this.setState({ feed_description: e.target.value })
              }
              placeholder="Add feed description.."
            /> */}
            <RichTextEditor
              handleEditor={this.handleEditorChange}
              editorState={this.state.feed_description}
              handleImageChange={this.showImage}
              placeholder={"Add feed description for feed detail page.."}
              wordCount={this.handleWordCount}
            />
          </div>
        </div>

        <div className="row">
          <div className="col-25">
            <label htmlFor="feed_activation">Is Active</label>
          </div>
          <div className="col-75">
            <input
              type="checkbox"
              id="feed_activation"
              name="activate_feed"
              checked={this.state.feed_activation}
              onChange={(e) =>
                this.setState({
                  feed_activation: e.target.checked,
                })
              }
            />
          </div>
        </div>
        <div className="row">
          <div className="col-25">
            <label htmlFor="feed_league_status">Show to league</label>
          </div>
          <div className="col-75">
            <input
              type="checkbox"
              id="feed_league_status"
              name="show_to_league"
              checked={this.state.show_to_league}
              onChange={(e) =>
                this.setState({
                  show_to_league: e.target.checked,
                })
              }
            />
          </div>
        </div>
        {/* <div className="row">
          <div className="col-25">
            <label htmlFor="feed-show-in-app">Show in app</label>
          </div>
          <div className="col-75">
            <input
              type="checkbox"
              id="feed-show-in-app"
              name="show-in-app"
              checked={this.state.feed_show_in_app}
              onChange={(e) =>
                this.setState({
                  feed_show_in_app: e.target.checked,
                })
              }
            />
          </div>
        </div>
        <div className="row">
          <div className="col-25">
            <label htmlFor="feed-show-in-web">Show in web</label>
          </div>
          <div className="col-75">
            <input
              type="checkbox"
              id="feed-show-in-web"
              name="show-in-web"
              checked={this.state.feed_show_in_web}
              onChange={(e) =>
                this.setState({
                  feed_show_in_web: e.target.checked,
                })
              }
            />
          </div>
        </div> */}
        <div className="row">
          <div className="col-25">
            <label htmlFor="curated_by">Curated By</label>
          </div>
          <div className="col-75">
            <input
              type="text"
              id="curated_by"
              name="feed_curation"
              value={this.state.curated_by}
              placeholder="Curated by Impact"
              onChange={(e) =>
                this.setState({
                  curated_by: e.target.value,
                })
              }
            />
          </div>
        </div>
        <div className="row">
          <div className="col-25">
            <label htmlFor="share_message">Share Message</label>
          </div>
          <div className="col-75">
            <input
              type="text"
              id="share_message"
              name="feed_share_message"
              value={this.state.feed_share_message}
              placeholder="Share message"
              onChange={(e) =>
                this.setState({
                  feed_share_message: e.target.value,
                })
              }
            />
          </div>
        </div>
        <div className="row">
          <div className="col-25">
            <label htmlFor="feed_url">Feed Url</label>
          </div>
          <div className="col-75">
            <input
              type="url"
              id="feed_url"
              name="feed_url"
              value={this.state.feed_url}
              placeholder="Feed URL"
              onChange={(e) =>
                this.setState({
                  feed_url: e.target.value,
                })
              }
            />
          </div>
        </div>
        <div style={{ margin: "15px 0px 40px 0px" }}>
          <button className="btn-feed" type="submit" onClick={this.updateFeed}>
            Update Feed
          </button>
        </div>
        <section style={{ textAlign: "center" }}>
          <Modal
            visible={this.state.visible}
            width="270"
            height="250"
            effect="fadeInDown"
            onClickAway={() => this.closeModal()}
          >
            <div style={{ margin: "30px" }}>
              <h2 style={{ padding: "10px" }}>Update Feed</h2>
              <p style={{ padding: "10px" }}>Feed updated Successfully</p>
              <button
                className="btn-feed"
                style={{ padding: "10px" }}
                onClick={() => this.closeModal()}
              >
                Ok
              </button>
            </div>
          </Modal>
        </section>
      </div>
    );
  }
}

async function getParticularPost(feed_id) {
  try {
    const response = await Axios.get(`/webposts/${feed_id}`, {
      headers: {
        authorization: cookies.get("authorization"),
      },
    });
    return response.data;
  } catch (error) {
    console.error(error);
  }
}

function getPostWordCount(editorState) {
  const plainText = editorState.getCurrentContent().getPlainText("");
  const regex = /(?:\r\n|\r|\n)/g; // new line, carriage return, line feed
  const cleanString = plainText.replace(regex, " ").trim(); // replace above characters w/ space
  const wordArray = cleanString.match(/\S+/g); // matches words according to whitespace
  return wordArray ? wordArray.length : 0;
}
